/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum OrganizationGroupType {
    Unknown = 'Unknown',
    Statsforvalteren = 'Statsforvalteren',
    Kommune = 'Kommune',
    DomesticCompany = 'DomesticCompany',
    ForeignCompany = 'ForeignCompany',
    MiscCompany = 'MiscCompany',
    Fylke = 'Fylke'
}


export function instanceOfOrganizationGroupType(value: any): boolean {
    for (const key in OrganizationGroupType) {
        if (Object.prototype.hasOwnProperty.call(OrganizationGroupType, key)) {
            if (OrganizationGroupType[key as keyof typeof OrganizationGroupType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OrganizationGroupTypeFromJSON(json: any): OrganizationGroupType {
    return OrganizationGroupTypeFromJSONTyped(json, false);
}

export function OrganizationGroupTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationGroupType {
    return json as OrganizationGroupType;
}

export function OrganizationGroupTypeToJSON(value?: OrganizationGroupType | null): any {
    return value as any;
}

export function OrganizationGroupTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): OrganizationGroupType {
    return value as OrganizationGroupType;
}

